import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import { Loading, PDF } from "../SVG";
import WebServiceContext from "../../webService/WebServiceContext";

/*
當傳入rowData資料的時候
則不使用type去fetch後端資料
改用rowData去render資料
*/

type NoticeTableProps = {
    type?: string
    rowData?: NoticeObj[]
    //loading?: boolean|null
    modalPDF?: (id: string) => void
}


type TWConfig = {
    [key: string]: (number | null)[]
}
let tableWidthConfig: TWConfig = {}
tableWidthConfig['保單未發單明細'] = [50, 100, 100, 100, 100, 200, 100, 100, 100, 100]
tableWidthConfig['新契約補全'] = [50, 50, 100, 100, 100, 100, 100, 300, 100]
tableWidthConfig['最近5日報件'] = [50, 100, 100, 100, 100, 100, 100, 100, 100, 100]


const NoticeTable = (props: NoticeTableProps) => {
    const ws = useContext(WebServiceContext)
    const [noticeData, setNoticeData] = useState<NoticeObj[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [THeaders, setTHeaders] = useState<string[]>([])

    useEffect(() => {
        if (props.type) {
            ws.webservice.asyncGetNotice(props.type).then((res: any) => {
                if (res) {
                    setNoticeData(res as NoticeObj[])
                    setIsLoading(false)
                    let _heads: string[] = []
                    for (let head in res[0]) {
                        _heads.push(head)
                    }
                    setTHeaders(_heads)
                }
            })
        }
        return
    }, [props.type])

    useEffect(() => {
        if (props.rowData) {
            setNoticeData(props.rowData)
            setIsLoading(false)
            let _heads: string[] = []
            for (let head in props.rowData[0]) {
                _heads.push(head)
            }
            setTHeaders(_heads)
        }
        return
    }, [props.rowData])



    const renderItem = (item: NoticeObj) => {
        const row = []
        let i: number = 0

        for (let key in item) {
            if (key == "pdf") {
                row.push(
                    <td key={"item" + i} >
                        {
                            item[key as keyof NoticeObj] != null &&
                            <button
                                className="icon-button"
                                onClick={() => {
                                    if (props.modalPDF) {
                                        props.modalPDF(item[key as keyof NoticeObj])
                                    }
                                }}>
                                <PDF />
                            </button>
                        }
                    </td>
                )
            } else {
                //const isLong = item[key as keyof NoticeObj] && item[key as keyof NoticeObj].toString().length > 24
                row.push(
                    <td key={"item" + i} >
                        {
                            item[key as keyof NoticeObj]
                        }
                        {/** 
                        <div
                            style={{                            
                                width:(isLong? 300:"auto"),
                                whiteSpace:(isLong? "normal":"nowarp"),
                            }} 
                        >
                            {
                                item[key as keyof NoticeObj]
                            }
                        </div>
                        */}
                    </td>
                )
            }
            i++
        }
        return (row)
    }

    if (isLoading) {
        return <Loading />
    } else if (!isLoading && noticeData.length == 0) {
        return <span>無資料</span>
    } else {
        return (
            <div className="tableBox">
                <table>
                    <thead>
                        <tr>
                            {
                                THeaders.map((item: string, index: number) =>{
                                    
                                    if(props.type && tableWidthConfig[props.type] && tableWidthConfig[props.type][index]){
                                        const _w:number= 
                                            tableWidthConfig[props.type][index]?
                                            tableWidthConfig[props.type][index] as number
                                            :0
                                        return(
                                            <th style={{width:_w}}  key={"tHead_" + index}>{item}</th>
                                        )
                                    }else{
                                        return(
                                            <th key={"tHead_" + index}>{item}</th>
                                        )
                                    }
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            noticeData.map(
                                (item: NoticeObj, index: number) =>
                                <tr key={"row_" + index}>{renderItem(item)}</tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default NoticeTable